import { Navigate, Outlet } from 'react-router-dom';
import Header from '@spa/components/Header/Header';
import SideNav from '@spa/components/Header/SideNav';
import MobileMenuLayout from '@spa/components/Header/MobileMenuLayout';
import { SpaRoutes } from '@spa/constants/routes';
import { isLoggedInSelector } from '@/store/selectors';
import { useAppSelector } from '@/store';
import PageLoader from '@spa/components/PageLoader';
import SupportWidget from '@spa/components/SupportWidget/SupportWidget';
import { useScrollDirection } from '@spa/hooks/useScrollDirection';
import PageTitle from '@spa/components/Header/PageTitle';

function AppLayout() {
  const isLoggedIn = useAppSelector(isLoggedInSelector);
  const isPageComplete = useAppSelector(({ global }) => global.isPageComplete);
  const scrollDirection = useScrollDirection(20, 100);

  if (!isPageComplete) {
    return <PageLoader />;
  }

  if (!isLoggedIn) {
    return <Navigate to={SpaRoutes.LOGOUT} replace />;
  }

  return (
    <>
      <div className="min-h-dvh lg:flex lg:flex-row">
        <SideNav />
        <div className="flex min-h-dvh flex-col gap-2 lg:gap-8 p-4 lg:p-8 flex-1 min-w-0">
          <div
            className={`
              hidden lg:block
              sticky top-0 z-50
              transition-transform duration-300 ease-in-out
              ${
                scrollDirection === 'down'
                  ? 'translate-y-[-200%]'
                  : 'translate-y-0'
              }
            `}
          >
            <Header />
          </div>

          <div
            className={`
              lg:hidden
              sticky z-50
              transition-all duration-300 ease-in-out
              bg-background
              ${
                scrollDirection === 'down'
                  ? 'translate-y-[-200%]'
                  : 'translate-y-0'
              }
              ${scrollDirection === 'up' ? 'top-3' : 'top-0'}
            `}
            style={{
              boxShadow: '0 -16px 0 var(--color-background)',
            }}
          >
            <MobileMenuLayout />
          </div>

          <main id="main" className="flex-1 pb-(--consent-banner-height)">
            <PageTitle />
            <Outlet />
          </main>
        </div>
      </div>
      <SupportWidget />
    </>
  );
}

export default AppLayout;
